import { Database, ShieldCheck, ScanSearch, CodeXml, Check, FileText, Ban } from 'lucide-react';
import './PrincipleCards.css';

const principles = [
  { key: 'source', label: 'VERIFIED SOURCE', title: '真实信源原则', detail: '真实 · 可验证', Icon: Database, desc: '所有优化内容基于企业真实工信信息、资质证书、用户评价等可验证信源，不隐瞒、不伪造。' },
  { key: 'integrity', label: 'CONTENT INTEGRITY', title: '拒绝虚假信息', detail: '真实内容守护', Icon: ShieldCheck, desc: '拒绝编造用户评价、拒绝伪造权威背书、拒绝制造虚假热度，所有信息可追溯、可验证。' },
  { key: 'audit', label: 'TRACEABLE PROCESS', title: '透明可审计', detail: '可解释 · 可追溯', Icon: ScanSearch, desc: '所有技术方法均可解释、可追溯、符合《生成式AI服务管理暂行办法》等法规要求。' },
  { key: 'standards', label: 'OPEN STANDARDS', title: '白帽技术栈', detail: '遵循公开标准', Icon: CodeXml, desc: '仅采用Schema标记、知识图谱对齐、合规内容结构化等公开标准技术，拒绝爬虫、拒绝撞库。' },
];

export default function PrincipleCards() {
  return (
    <div className="principle-cards" data-principles-grid>
      {principles.map((principle, index) => {
        const Icon = principle.Icon;
        return (
          <article className="principle-card" key={principle.key}>
            <div className={`principle-card__visual principle-card__visual--${principle.key}`} aria-hidden="true">
              <span className="principle-card__label">{principle.label}</span>
              <div className="principle-card__sheet">
                <div className="principle-card__sheet-bar"><i /><i /><i /></div>
                {principle.key === 'source' ? <><FileText size={22} /><div className="principle-card__lines"><i /><i /><i /></div><span className="principle-card__verified"><Check size={9} /> 信息核验</span></>
                  : principle.key === 'integrity' ? <div className="principle-card__checks"><span><Check size={12} /> 真实内容</span><span><Ban size={12} /> 拒绝伪造</span></div>
                  : principle.key === 'audit' ? <div className="principle-card__audit"><span /><i /><span /><i /><span /><small>信源 → 方法 → 记录</small></div>
                  : <div className="principle-card__code"><strong>{'{ }'}</strong><span>Schema.org</span><small>结构化内容</small></div>}
              </div>
              <div className="principle-card__icon"><Icon size={34} strokeWidth={1.35} /></div>
              <div className="principle-card__badge"><Check size={10} />{principle.detail}</div>
            </div>
            <div className="principle-card__body"><h3><span>0{index + 1}</span>{principle.title}</h3><p>{principle.desc}</p></div>
          </article>
        );
      })}
    </div>
  );
}
